<script lang="ts" setup>
import {computed} from 'vue';

import SessionItem from "@src/components/shared/session/SessionItem.vue";
import NoSessions from "@src/components/states/empty-states/NoSessions.vue";
import {useChatSessionStore} from "@src/stores/chatSession";
import {ChatBubbleLeftIcon} from "@heroicons/vue/24/solid";
import {shorten} from "@src/helpers/utils";
import {useDepartments} from "@src/composables/useDepartments";


const props = defineProps<{
    sessions?: any[] | null
}>();

const sessionStore = useChatSessionStore();
const { getDepartments } = useDepartments();
const departments = getDepartments();

const departmentMap = computed(() => {
    const map: Record<number, string> = {};
    (departments.value ?? []).forEach((dep: any) => {
        map[dep.id] = dep.name;
    });
    return map;
});

const sessionsList = computed(() => {
    return Array.isArray(props.sessions) ? props.sessions : [];
});

const groupedSessions = computed(() => {
  const groups: Record<string, any> = {};

    sessionsList.value.forEach((session: any) => {
    const departmentId = session.department?.id ?? session.department_id ?? 'no-department';
    const departmentName = session.department?.name
        ?? (session.department_id ? departmentMap.value[session.department_id] : null)
        ?? 'Sem departamento';

    if (!groups[departmentId]) {
      groups[departmentId] = {
        departmentName,
        sessions: [],
        count: 0
      };
    }

    groups[departmentId].sessions.push(session);
    groups[departmentId].count++;
  });

    Object.values(groups).forEach((group: any) => {
        group.sessions.sort((a: any, b: any) =>
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
        );
    });

    return Object.values(groups).sort((a, b) => a.sessions.length - b.sessions.length);
});

</script>

<template>
  <div class="h-full overflow-y-auto scrollbar-thin">

    <template v-if="groupedSessions.length">

      <div v-for="group in groupedSessions" :key="group.departmentName" class="md:px-4">

        <!-- Nome do departamento -->
        <div class="px-4 py-2 text-xs font-bold text-white uppercase flex justify-between bg-brand-400 rounded-t dark:bg-brand-500">
          <span class="mt-1">{{(shorten(group.departmentName, 28))}}</span>
          <div class="flex items-center">
            <ChatBubbleLeftIcon class="w-[14px] h-[14px] font-semibold mr-2"/>
            <span class="mt-1">{{ group.count }}</span>
          </div>
        </div>

        <!-- Sessões -->
        <SessionItem
            v-for="session in group.sessions"
            :id="session.id"
            :key="session.id"
            :avatar="session.costumer?.profile_picture || 'https://sistema.dchat.com.br/images/avatar.jpg'"
            :costumer-id="session.costumer?.id"
            :department="session.department?.name"
            :has-new-message="session.has_new_messages"
            :isExpired="session.is_expired"
            :isFixed="session.is_fixed"
            :isSpin="session.is_spin"
            :last-message="session.last_message ?? null"
            :last-message-date="session.last_message?.created_at"
            :name="session.costumer?.name || 'Cliente'"
            :status="session.status"
            :type="session.channel?.type || 'whatsapp'"
            @click="sessionStore.selectSession(session)"
        />

      </div>

    </template>

    <NoSessions v-else/>

  </div>
</template>

<style scoped>

</style>